module.exports = __webpack_public_path__ + "static/AlbertChoResume-2-523f6923de1fc9571a554fb0f01ce65f.pdf";